import React, { useEffect, useRef, useState } from 'react'
// import { Editor } from '@tinymce/tinymce-react';
import JoditEditor from "jodit-react";
import Grid from '@mui/material/Grid2';
import "./knowledge.css";
import dayjs from 'dayjs';
import Select from 'react-select';
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { apiService } from '../../services/apiService';
import { useNavigate } from 'react-router-dom';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faXmark } from '@fortawesome/free-solid-svg-icons';
import { faFileLines } from '@fortawesome/free-regular-svg-icons';
import { toast } from 'react-toastify';
import NavigationPrompt from '../../components/Navblocker/NavigationPrompt';
import debounce from "lodash.debounce";
import { AsyncPaginate } from 'react-select-async-paginate';

function DraftAdd() {
    const navigate = useNavigate();
    const authorName = localStorage.getItem('usernames');
    const [catsShows, setCatsshow] = useState(false);
    const [subCatsShows, setSubCatsshow] = useState(false);
    const [baseids, setBaseid] = useState([]);
    const [taskType, setTaskType] = useState([]);
    const [categoryId, setCategoryid] = useState([]);
    const [subcategoryId, setSubCategoryid] = useState([]);
    const [selectedBaseid, setSelectedBaseid] = useState(null);
    const [selectedCatId, setSelectedCategoryid] = useState(null);
    const [selectedTask, setSelectedTask] = useState([]);
    const [selectedCaseType, setSelectedCaseType] = useState(null);
    const [selectedCaseSubType, setSelectedCaseSubType] = useState([]);
    const [optionsKey, setOptionsKey] = useState(0);
    const [selectedsubCatId, setSelectedsubCategoryid] = useState(null);
    const [previewer, setPreview] = useState("");
    const [submitloader, setSubmitloader] = useState("");
    // const tomorrow = dayjs().add(1, 'day');
    // const [value, setValue] = useState(dayjs(null));
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [files, setFiles] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [newName, setNewName] = useState('');
    const [error, setError] = useState('');
    const [backActive, setBackActive] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const fileInputRef = useRef(null);
    const [uploadPercentage, setUploadPercentage] = useState(0);

    const MAX_FILES = 10;
    const MAX_TOTAL_SIZE_MB = 2500;
    const MAX_FILE_SIZE_MB = 250;
    const allowedTypes = [
        'image/jpeg', 'image/png', 'image/gif',
        'application/pdf',
        'text/csv',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel', // xls files
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx files
        'application/vnd.ms-powerpoint',                                          // .ppt
        'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
        
        'video/mp4',
        'video/webm',
        'video/ogg',
        // audio files
        'audio/mpeg',      // .mp3
        'audio/wav',       // .wav
        'audio/ogg',       // .ogg
        'audio/webm',      // .webm
        'audio/aac',       // .aac
        'audio/mp4',       // .m4a
        'audio/flac',
        'audio/x-m4a'      // .m4a (alternative MIME type)
    ];
    const clearDropdownOptions = () => {
        setOptionsKey(prev => prev + 1);
    };
    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
        const params = {
            search: searchQuery,
            page : page
        }
        try {
        const response = await apiService.postRequest(
            `case-types/options`, params
        );
        if(response && response.success === true){
        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.name,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
            page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };
    const loadOptionsSubtype = async (searchQuery, loadedOptions,  { page }) => {
        const valuesArray = selectedCaseType.map(({ value }) => Number(value));
        const params = {
            case_type_id: valuesArray,
            search: searchQuery,
            page : page,
        }
        try {
        const response = await apiService.postRequest(
            `case-sub-types/options`, params
        );
        if(response && response.success === true){
        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.name,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
                page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };
    const fetchSuggestions = async (query) => {
        if (!query) {
          setSuggestions([]); // Clear suggestions if input is empty
          return;
        }
    
        try {
          const response = await apiService.postRequest("knowledge-article/tag-suggestions", { query });
          if(response && response.success){
              setSuggestions(response.tags || []); // Adjust based on API response
          }else{
            if(response && response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
          }
        } catch (error) {
          console.error("Error fetching suggestions:", error);
        }
    };
    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);

        // Check if total number of files exceeds limit
        if (files.length + selectedFiles.length > MAX_FILES) {
            setError(`You can only upload up to ${MAX_FILES} files.`);
            return;
        }

        // Check each file size and type
        for (const file of selectedFiles) {
            if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
                setError(`Each file must be less than ${MAX_FILE_SIZE_MB} MB.`);
                return;
            }
            if (!allowedTypes.includes(file.type)) {
                setError('Only image files (JPEG, PNG, GIF), CSV, PDF, XLS, XLSX, PPT, MP4, WEBM, OGG, Audio and Word files are allowed.');
                return;
            }
        }

        // Check total combined size of all files
        const currentSize = files.reduce((acc, file) => acc + file.file.size, 0);
        const newSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);
        if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
            setError(`Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`);
            return;
        }

        setError('');
        const updatedFiles = selectedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
        fileInputRef.current.value = null;
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);

        // Check if total number of files exceeds limit
        if (files.length + droppedFiles.length > MAX_FILES) {
            setError(`You can only upload up to ${MAX_FILES} files.`);
            return;
        }

        // Check each file size and type
        for (const file of droppedFiles) {
            if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
                setError(`Each file must be less than ${MAX_FILE_SIZE_MB} MB.`);
                return;
            }
            if (!allowedTypes.includes(file.type)) {
                setError('Only image files (JPEG, PNG, GIF), CSV, PDF, XLS, XLSX, PPT, MP4, WEBM, OGG, Audio and Word files are allowed.');
                return;
            }
        }

        // Check total combined size of all files
        const currentSize = files.reduce((acc, file) => acc + file.file.size, 0);
        const newSize = droppedFiles.reduce((acc, file) => acc + file.size, 0);
        if (currentSize + newSize > MAX_TOTAL_SIZE_MB * 1024 * 1024) {
            setError(`Total file size cannot exceed ${MAX_TOTAL_SIZE_MB} MB.`);
            return;
        }

        setError('');
        const updatedFiles = droppedFiles.map((file) => ({
            file,
            name: file.name,
        }));
        setFiles((prevFiles) => [...prevFiles, ...updatedFiles]);
    };


    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        // Reset the file input to allow the same file to be uploaded again
        fileInputRef.current.value = null;
    };

    const handleRenameFile = (index) => {
        const originalName = files[index].file.name;
        const fileExtension = originalName.split('.').pop();
        const updatedName = newName ? `${newName}.${fileExtension}` : originalName;
        
        setFiles((prevFiles) => {
            const updatedFiles = [...prevFiles];
            updatedFiles[index].name = updatedName;
            return updatedFiles;
        });

        setEditIndex(null); // Close the edit popup
        setNewName(''); // Reset the new name
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };


    const [formData, setFormData] = useState({
        title: '',
        short_description: '',
        retired_date: '',
        planned_release_date: '',
        status: '',
        tags:"",
        task_type: [],
        base_id: '',
        category_id: '',
        subcategory_id: '',
        content: '',
        is_external: 0,
        is_preview_render: 0,
        case_type_id: '',
        case_sub_type_id: '',
    });
    const [tags, setTags] = useState([]);
    const [input, setInput] = useState("");

    const handleInputChanger = (e) => {
        setInput(e.target.value);
        fetchSuggestions(e.target.value);
        if (errors.tags) {
            setErrors(prevErrors => ({ ...prevErrors, tags: undefined }));
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && input.trim()) {
            e.preventDefault();
            const newTag = input.trim();
            if (!tags.includes(newTag)) {
                const updatedTags = [...tags, newTag];
                setTags(updatedTags);

                // Update the formData tag property to a comma-separated string or join the tags array as needed
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    tags: updatedTags.join(", "), // Join tags into a single string if needed
                }));
            }else{
                setSuggestions([]);
            }
            setInput("");
        }
    };
    const handleSuggestionClick = (suggestion) => {
        if (!tags.includes(suggestion)) {
          setTags([...tags, suggestion]);
        }
        setInput(""); // Clear input
        setSuggestions([]); // Hide suggestions
      };
    const removeTag = (index) => {
        const updatedTags = tags.filter((tag, i) => i !== index);
        setTags(updatedTags);

        // Update the formData tag property to reflect the removed tag
        setFormData((prevFormData) => ({
            ...prevFormData,
            tag: updatedTags.join(", "), // Update to a comma-separated string if needed
        }));
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));

        setFormData({ ...formData, [name]: value });
    };
    const contentRef = useRef("");
    const debouncedOnChange = debounce((value) => {
    const cleanValue = value === "<p><br></p>" ? "" : value;
    contentRef.current = cleanValue;
    }, 500);
    
    const [selectedOption, setSelectedOption] = useState(null);
    const [customDate, setCustomDate] = useState(null);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const tomorrow = dayjs().add(1, "day").toDate(); // Min date is tomorrow
    const [isSelectActive, setIsSelectActive] = useState(false);
    // Options for dropdown
    const getOptions = () => [
        { label: "After 2 weeks", value: "2_weeks" },
        { label: "After 1 month", value: "1_month" },
        { label: "After 3 months", value: "3_months" },
        { label: "After 6 months", value: "6_months" },
        { label: "After a year", value: "1_year" },
        { label: customDate ? "On a specific date" : "On a specific date", value: "custom" },
    ];

    // Function to calculate retirement date
    const calculateRetirementDate = (value) => {
        const today = dayjs();
        switch (value) {
        case "2_weeks":
            return today.add(2, "week").toDate();
        case "1_month":
            return today.add(1, "month").toDate();
        case "3_months":
            return today.add(3, "month").toDate();
        case "6_months":
            return today.add(6, "month").toDate();
        case "1_year":
            return today.add(1, "year").toDate();
        default:
            return null;
        }
    };
    
    const handleOptionChange = (selected) => {
        setSelectedOption(selected);
    
        if (selected.value !== "custom") {
            const calculatedDate = calculateRetirementDate(selected.value);
            setCustomDate(null);
            
            // Update form data
            setFormData({ ...formData, retired_date: dayjs(calculatedDate).format("YYYY-MM-DD") });
    
            // Update selected option label to show the calculated date
            setSelectedOption({
                label: `${dayjs(calculatedDate).format("YYYY-MM-DD")}`,
                value: selected.value
            });
    
            setShowDatePicker(false);
    
            if (errors.retired_date) {
                setErrors({ ...errors, retired_date: "" });
            }
        } else {
            setShowDatePicker(true);
        }
    };

    const handleDateChange = (date) => {
        if (date) {
        setCustomDate(date);
        setFormData({ ...formData, retired_date: dayjs(date).format("YYYY-MM-DD") });

        // Update dropdown to show the selected date
        setSelectedOption({ label: dayjs(date).format("YYYY-MM-DD"), value: "custom" });

        setShowDatePicker(false); // Close calendar

        if (errors.retired_date) {
            setErrors({ ...errors, retired_date: "" });
        }
        }
    };

    // ---- Planned Release Date (independent state & handlers) ----
    const [selectedReleaseOption, setSelectedReleaseOption] = useState(null);
    const [customReleaseDate, setCustomReleaseDate] = useState(null);
    const [showReleaseDatePicker, setShowReleaseDatePicker] = useState(false);
    const [isReleaseSelectActive, setIsReleaseSelectActive] = useState(false);

    const handleReleaseOptionChange = (selected) => {
        setSelectedReleaseOption(selected);

        if (selected.value !== "custom") {
            const calculatedDate = calculateRetirementDate(selected.value);
            setCustomReleaseDate(null);

            // Update form data
            setFormData({ ...formData, planned_release_date: dayjs(calculatedDate).format("YYYY-MM-DD") });

            // Update selected option label to show the calculated date
            setSelectedReleaseOption({
                label: `${dayjs(calculatedDate).format("YYYY-MM-DD")}`,
                value: selected.value
            });

            setShowReleaseDatePicker(false);

            if (errors.planned_release_date) {
                setErrors({ ...errors, planned_release_date: "" });
            }
        } else {
            setShowReleaseDatePicker(true);
        }
    };

    const handleReleaseDateChange = (date) => {
        if (date) {
        setCustomReleaseDate(date);
        setFormData({ ...formData, planned_release_date: dayjs(date).format("YYYY-MM-DD") });

        // Update dropdown to show the selected date
        setSelectedReleaseOption({ label: dayjs(date).format("YYYY-MM-DD"), value: "custom" });

        setShowReleaseDatePicker(false); // Close calendar

        if (errors.planned_release_date) {
            setErrors({ ...errors, planned_release_date: "" });
        }
        }
    };
    useEffect(() => {
        if (formData.title === "" 
            && formData.short_description === ""
            && formData.retired_date === ""
            && formData.base_id === ""
            && formData.category_id === ""
            && formData.subcategory_id === ""
            && formData.content === ""
        ) {
            setBackActive(false);
        }else{
            setBackActive(true);
        }
    }, [formData.title,formData.short_description,formData.retired_date,formData.base_id,formData.category_id,formData.subcategory_id,formData.content]);
    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.getRequest('knowledge-bases-with-task-types');
            if (response.success) {
                setBaseid(response.data);
                setTaskType(response.taskTypes);
            }
        };
        fetchData();
    }, []);
    
    useEffect(() => {
        if (formData.base_id) {
            const fetchData = async () => {
                const response = await apiService.getRequest(`knowledge-article-categories-list/${formData.base_id}`);
                if (response.success) {
                    setCategoryid(response.data || []);
                    setSelectedCategoryid(null);
                }
            };
            fetchData();
        }
    }, [formData.base_id]);
    
    useEffect(() => {
        if (formData.category_id) {
            const fetchData = async () => {
                const response = await apiService.getRequest(`knowledge-article-subcategories-list/${formData.category_id}`);
                if (response.success) {
                    setSubCategoryid(response.data || []);
                    setSelectedsubCategoryid(null);
                }
            };
            fetchData();
        }
    }, [formData.category_id]);

    const handlebaseidChange = (selectedOption) => {
        setSelectedBaseid(selectedOption);
        handleInputChange({
            target: {
                name: 'base_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
        setSelectedCategoryid(null);
        setCategoryid([]);
        setSubCategoryid([]);
    };

    const handleCatidChange = (selectedOption) => {
        setSelectedCategoryid(selectedOption); // Update city
        handleInputChange({
            target: {
                name: 'category_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
        setSelectedsubCategoryid(null);
        setSubCategoryid([]);
    };
    useEffect(() => {
        if (selectedBaseid) {
            setCatsshow(true);
        }else{
            setCatsshow(false);
        }
        if (selectedCatId) {
            setSubCatsshow(true);
        }else{
            setSubCatsshow(false);
        }
    }, [selectedBaseid,selectedCatId]);
    const handleTaskChange = (selectedOptions) => {
        setSelectedTask(selectedOptions); // Update the state for selected tasks
    
        // Update the formData with the selected task types as an array
        setFormData(prevFormData => ({
            ...prevFormData,
            task_type: selectedOptions ? selectedOptions.map(option => option.label) : [], // Store as an array
        }));
    };
    const handleSubCatidChange = (selectedOption) => {
        setSelectedsubCategoryid(selectedOption);
        handleInputChange({
            target: {
                name: 'subcategory_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
    };
    const handleCaseSubType = (selectedOptions) => {
        setSelectedCaseSubType(selectedOptions); // Update the selected options for display
    
        // Extract values from the selected options array
        const selectedValues = selectedOptions ? selectedOptions.map(option => Number(option.value)) : [];
    
        // Update formData with the selected values (as an array)
        setFormData((prevFormData) => ({
            ...prevFormData,
            case_sub_type_id: selectedValues,
        }));
        if (errors.case_sub_type_id) {
            setErrors({ ...errors, case_sub_type_id: '' });
        }
    };
    const handleCaseTypeChange = (selectedOptions) => {
        setSelectedCaseType(selectedOptions); // Update the selected options for display
        setSelectedCaseSubType([]);
        clearDropdownOptions();
        const selectedValues = selectedOptions ? selectedOptions.map(option => Number(option.value)) : [];
    
        // Update formData with the selected values (as an array)
        setFormData((prevFormData) => ({
            ...prevFormData,
            case_type_id: selectedValues,
            case_sub_type_id: [],
        }));
        if (errors.case_type_id) {
            setErrors({ ...errors, case_type_id: '' });
        }
    };
    const validateForm = (data) => {
        let valid = true;
        const errors = {};
        
        if (!formData.title || formData.title.trim() === '') {
            errors.title = 'Title is required.';
            valid = false;
        }
        if (!formData.short_description || formData.short_description.trim() === '') {
            errors.short_description = 'Description is required.';
            valid = false;
        }
        if (formData.short_description && formData.short_description.length < 3) {
            errors.short_description = "Description must be at least 3 characters long";
        }else if (formData.short_description && formData.short_description.length > 4000) {
            errors.short_description = ['Description must be less than 4000 characters long.'];
        }
    
        // Custom validation for retired_date (e.g., required and valid date format)
        if (!formData.retired_date || formData.retired_date.trim() === '') {
            errors.retired_date = 'Retired date is required.';
            valid = false;
        }else if (!dayjs(formData.retired_date, 'YYYY-MM-DD', true).isValid()) {
            errors.retired_date = 'Invalid date format. Use YYYY-MM-DD.';
            valid = false;
        }
        
    
        // Custom validation for base_id (e.g., required field)
        if (!formData.base_id) {
            errors.base_id = 'Base ID is required.';
            valid = false;
        }
    
        // Custom validation for category_id (e.g., required field)
        if (!formData.category_id) {
            errors.category_id = 'Category ID is required.';
            valid = false;
        }
    
        // Custom validation for subcategory_id (e.g., required field)
        if (!formData.subcategory_id) {
            errors.subcategory_id = 'Subcategory ID is required.';
            valid = false;
        }
    
        // Custom validation for content (e.g., required field)
        if (!data.content || data.content.trim() === '') {
            errors.content = 'Content is required.';
            valid = false;
        }
    
        if (!tags.length) {
            errors.tags = 'At least one tag is required.';
            valid = false;
        }
        // Set errors if any field is invalid
        setErrors(errors);
    
        return valid;  // Return true if valid, false otherwise
    };
    const handleSubmit = async (e, status, previewer) => {
        e.preventDefault();
      
        const contentValue = contentRef.current;
      
        const updatedFormData = {
          ...formData,
          content: contentValue,
        };
      
        if (!validateForm(updatedFormData)) {
          setErrorMessage('Please fix the errors before proceeding.');
          return;
        }
      
        // Update the state later — but don't depend on it in this function
        setFormData(updatedFormData);
        setPreview(previewer);
        setSubmitloader(status);
      
        try {
          const formDataToSend = new FormData();
      
          for (const key in updatedFormData) {
            if (Array.isArray(updatedFormData[key])) {
              updatedFormData[key].forEach(value => formDataToSend.append(key + '[]', value));
            } else {
              formDataToSend.append(key, updatedFormData[key]);
            }
          }
      
          if (!updatedFormData.task_type || updatedFormData.task_type.length === 0) {
            formDataToSend.append("task_type[]", []);
          }
      
          formDataToSend.append('tags', tags.join(", "));
      
          files.forEach((file) => {
            formDataToSend.append('documents[]', file.file);
            formDataToSend.append('document_name[]', file.name);
          });
      
          formDataToSend.append('status', status);
      
          const config = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
      
          if (files.length > 0) {
            config.onUploadProgress = (progressEvent) => {
              if (progressEvent.total) {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setUploadPercentage(percentCompleted);
              }
            };
          }
      
          const response = await apiService.postRequest("knowledge-article", formDataToSend, config);
          setUploadPercentage(0);
      
          if (response?.success === true) {
            setErrors({});
            setErrorMessage('');
      
            const isPreviewer = previewer === "true";
      
            if (isPreviewer && response.data.status === "draft") {
              navigate(`/knowledge/preview/${response.data.id}`);
              toast('Article Saved to Draft successfully!');
            } else if (response.data.status === "draft") {
              navigate(`/knowledge/edit-article/${response.data.id}`);
              toast('Article Saved to Draft successfully!');
            } else if (status === "under_approval") {
              navigate('/knowledge/under-approval');
              toast('Article Moved to Approval successfully!');
            } else {
              setBackActive(false);
            }
          } else {
            setErrorMessage(response?.message || 'Save failed. Please try again.');
            setErrors(response?.errors || {});
            if(response && response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
          }
        } catch (error) {
          console.error('Error submitting the form:', error);
        } finally {
          setSubmitloader("");
        }
    };
    const styles = {
        tagContainer: {
            display: "flex",
            flexWrap: "wrap",
            padding: "0px",
            border: "none",
            borderRadius: "5px",
        },
        tag: {
            display: "flex",
            alignItems: "center",
            backgroundColor: "#B8D7FF",
            borderRadius: "3px",
            padding: "5px",
            marginRight: "5px",
            marginBottom: "5px",
            fontWeight:"600",
        },
        removeButton: {
            marginLeft: "5px",
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "16px",
        },
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <NavigationPrompt 
                when={backActive}
                message="You have unsaved changes. Are you sure you want to leave?"
            />
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Draft</h3>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container flexDirection="column" className="my-4 tab_cont_draft">
                    <Tabs
                        defaultActiveKey="article"
                        id="uncontrolled-tab-example"
                        className="mb-3 drafttabs_tabs "
                    >
                    <Tab eventKey="article" title="Article" className='w-100'>
                        <Grid size={{xs:12}} container justifyContent="center">
                        {uploadPercentage > 0 ? (
                            <div className='d-flex justify-content-center align-items-center w-100 mt-5' style={{minHeight : "60vh"}}>
                                <div style={{ marginTop: "10px", width: "100%", backgroundColor: "#ddd",overflow:"hidden",borderRadius:"20px" }}>
                                    <div
                                        style={{
                                        width: `${uploadPercentage}%`,
                                        backgroundColor: "#C42B7D",
                                        color: "white",
                                        textAlign: "center",
                                        padding: "3px",
                                        }}
                                    >
                                        {uploadPercentage}%
                                    </div>
                                </div>
                            </div>
                        ):
                        <form className='w-100 row justify-content-center' 
                        onSubmit={handleSubmit}
                        >
                            <Grid size={{lg:12,xs:12}} container justifyContent="space-between">
                                <Grid size={{sm:12, xs:12}} container justifyContent="flex-end" className="gap-md-4 gap-2">
                                <button
                                    style={{ width: "max-content" }}
                                    className="registersendbtn2 px-4"
                                    type="submit"
                                    onClick={(e) => handleSubmit(e, "under_approval", "false")}
                                    >
                                    {submitloader === "under_approval" ? (
                                        <img src={require('../../assets/whiteloader.gif')} alt='' />
                                    ) : (
                                        'Request for Approval'
                                    )}
                                    </button>

                                    <button
                                    className="registersendbtn1"
                                    type="submit"
                                    onClick={(e) => {handleSubmit(e, "draft", "false");}}
                                    >
                                    {(submitloader === "draft" && previewer === "false") ? (
                                        <img src={require('../../assets/pinkloader.gif')} alt='' />
                                    ) : (
                                        'Save'
                                    )}
                                    </button>

                                    <button
                                        className="registersendbtn1"
                                        type='button'
                                        onClick={() => {
                                            if(!backActive){
                                                navigate("/knowledge/draft");
                                            }else{
                                                setShow(true);
                                            }
                                        }}
                                    >
                                    Back
                                    </button>

                                    <button
                                    className="registersendbtn1"
                                    type="submit"
                                    onClick={(e) => handleSubmit(e, "draft", "true")}
                                    >
                                    {(submitloader === "draft" && previewer === "true") ? (
                                        <img src={require('../../assets/pinkloader.gif')} alt='' />
                                    ) : (
                                        'Preview'
                                    )}
                                    </button>
                                </Grid>
                                <Grid size={{xs:12}} container justifyContent="space-between" className="darfts_inputs">
                                    <Grid size={{xs:12}} container flexDirection="column" className="author_spans">
                                        <span className='mt-0'>Author</span>
                                        <h5>{authorName}</h5>
                                    </Grid>
                                    <Grid size={{sm:12, xs:12}} container flexDirection="column" className="">
                                        <span>Title<small>*</small></span>
                                        <input
                                            type="text"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleInputChange}
                                        />
                                        {errors.title && <p style={{ color: "Red" }}>{errors.title}</p>}
                                    </Grid>
                                    <Grid size={{sm:5.8, xs:12}} container className="my-3" flexDirection="column">
                                        <span>External</span>
                                        <span className='mt-0 job_boardspancheckadd'>
                                            <input type='checkbox' checked={formData.is_external === 1}
                                            onChange={(e) => 
                                                handleInputChange({
                                                target: { name: "is_external", value: e.target.checked ? 1 : 0 }
                                                })
                                            }/>
                                        External people can see this article.</span>
                                        {errors.is_external && <p style={{color:"Red"}}>{errors.is_external[0]}</p>}
                                    </Grid>
                                    <Grid size={{sm:5.8, xs:12}} container className="my-3" flexDirection="column">
                                        <span>Export PDF</span>
                                        <span className='mt-0 job_boardspancheckadd'>
                                            <input type='checkbox' checked={formData.is_preview_render === 1}
                                            onChange={(e) => 
                                                handleInputChange({
                                                target: { name: "is_preview_render", value: e.target.checked ? 1 : 0 }
                                                })
                                            }/>
                                        People can export this article as a PDF.</span>
                                        {errors.is_preview_render && <p style={{color:"Red"}}>{errors.is_preview_render}</p>}
                                    </Grid>
                                    <Grid size={{sm:12, xs:12}} container flexDirection="column" className="">
                                        <span>Description<small>*</small></span>
                                        <textarea
                                            className='textarea_community pt-1'
                                            type="text"
                                            minLength="3" maxLength="4001"
                                            name="short_description"
                                            value={formData.short_description}
                                            onChange={handleInputChange}
                                        />
                                        {errors.short_description && <p style={{ color: "Red" }}>{errors.short_description}</p>}
                                    </Grid>
                                    <Grid size={{sm:5.8, xs:12}} style={{ position: "relative" }} container flexDirection="column">
                                        <span>Retire Date<small>*</small></span>
                                        <Select
                                            className="basic-single select_withsearch"
                                            classNamePrefix="select"
                                            options={getOptions()}
                                            value={selectedOption}
                                            onChange={handleOptionChange}
                                            placeholder="Select retirement date"
                                            onFocus={() => setIsSelectActive(true)}
                                            onBlur={() => setIsSelectActive(false)}
                                        />

                                        {/* Floating Calendar */}
                                        {showDatePicker && (
                                            <div style={{ position: "absolute", top: "100%", right: 0, zIndex: isSelectActive ? 0 : 1, }}>
                                            <DatePicker className="react_datepickerretire"
                                                value={customDate}
                                                onChange={handleDateChange}
                                                minDate={tomorrow}
                                                clearIcon={null}
                                                autoFocus
                                                isOpen
                                            />
                                            </div>
                                        )}
                                            {errors.retired_date && <p style={{ color: "Red" }}>{errors.retired_date}</p>}
                                    </Grid>
                                    <Grid size={{sm:5.8, xs:12}} style={{ position: "relative" }} container flexDirection="column">
                                        <span>Planned Release Date</span>
                                        <Select
                                            className="basic-single select_withsearch"
                                            classNamePrefix="select"
                                            options={getOptions()}
                                            value={selectedReleaseOption}
                                            onChange={handleReleaseOptionChange}
                                            placeholder="Select planned release date"
                                            onFocus={() => setIsReleaseSelectActive(true)}
                                            onBlur={() => setIsReleaseSelectActive(false)}
                                        />

                                        {/* Floating Calendar */}
                                        {showReleaseDatePicker && (
                                            <div style={{ position: "absolute", top: "100%", right: 0, zIndex: isReleaseSelectActive ? 0 : 1, }}>
                                            <DatePicker className="react_datepickerretire"
                                                value={customReleaseDate}
                                                onChange={handleReleaseDateChange}
                                                minDate={tomorrow}
                                                clearIcon={null}
                                                autoFocus
                                                isOpen
                                            />
                                            </div>
                                        )}
                                        {errors.planned_release_date && <p style={{ color: "Red" }}>{errors.planned_release_date}</p>}
                                    </Grid>
                                    <Grid size={{xs:12}} container>
                                        <Grid size={{sm:5.8, xs:12}} container flexDirection="column">
                                            <span>Version<small>*</small></span>
                                            <input type='text' value={1} disabled/>
                                        </Grid>
                                    </Grid>
                                    <Grid size={{sm:5.8, xs:12}} container alignItems="flex-start" alignContent="flex-start">
                                        <Grid size={{xs:12}} container flexDirection="column">
                                            <span>Knowledge Base<small>*</small></span>
                                            <Select
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                value={selectedBaseid}
                                                defaultValue={null}
                                                name="base_id"
                                                options={baseids && baseids.map((state) => ({
                                                    label: state.name,
                                                    value: state.id,
                                                }))}
                                                onChange={handlebaseidChange}
                                            />
                                            {errors.base_id && <p style={{color:"Red"}}>{errors.base_id}</p>}
                                        </Grid>
                                        {catsShows &&
                                        <Grid size={{xs:12}} container flexDirection="column">
                                            <span>Category<small>*</small></span>
                                            <Select
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                value={selectedCatId}
                                                defaultValue={null}
                                                name="category_id"
                                                options={categoryId.map((cates) => ({
                                                    label: cates.name,
                                                    value: cates.id,
                                                }))}
                                                onChange={handleCatidChange}
                                            />
                                            {errors.category_id && <p style={{color:"Red"}}>{errors.category_id}</p>}
                                        </Grid>}
                                        {subCatsShows &&
                                        <Grid size={{xs:12}} container flexDirection="column">
                                            <span>Sub Category<small>*</small></span>
                                            <Select
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                value={selectedsubCatId}
                                                defaultValue={null}
                                                name="subcategory_id"
                                                options={subcategoryId.map((subcates) => ({
                                                    label: subcates.name,
                                                    value: subcates.id,
                                                }))}
                                                onChange={handleSubCatidChange}
                                            />
                                            {errors.subcategory_id && <p style={{color:"Red"}}>{errors.subcategory_id}</p>}
                                        </Grid>}
                                    </Grid>
                                    <Grid size={{sm:5.8, xs:12}} container alignItems="flex-start" alignContent="flex-start">
                                        <Grid size={{xs:12}} container flexDirection="column">
                                            <span>Select All Applicable Task Types</span>
                                            <Select
                                                isMulti
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                value={selectedTask}
                                                defaultValue={null}
                                                name="task_type"
                                                options={taskType && taskType.map((task) => ({
                                                    label: task.name,
                                                    value: task.name,
                                                }))}
                                                onChange={handleTaskChange}
                                            />
                                            {errors.task_type && <p style={{color:"Red"}}>{errors.task_type}</p>}
                                        </Grid>
                                        <Grid size={{xs:12}} container flexDirection="column">
                                            <span>Applicable Case Types</span>
                                            <AsyncPaginate
                                                isMulti
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                loadOptions={loadOptions}
                                                value={selectedCaseType}
                                                additional={{
                                                    page: 1,
                                                }}
                                                debounceTimeout={300}
                                                onChange={handleCaseTypeChange}
                                                isClearable
                                                cacheUniqs={[]}
                                                reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]} 
                                            />
                                            {errors.case_type_id && <p style={{color:"Red"}}>{errors.case_type_id}</p>}
                                        </Grid>
                                        {selectedCaseType?.length > 0 &&
                                        <Grid size={{xs:12}} container flexDirection="column">
                                            <span>Applicable Case Sub Types</span>
                                            <AsyncPaginate
                                                key={optionsKey}
                                                isMulti
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                loadOptions={loadOptionsSubtype}
                                                value={selectedCaseSubType}
                                                additional={{
                                                    page: 1,
                                                }}
                                                debounceTimeout={300}
                                                onChange={handleCaseSubType}
                                                isClearable
                                                cacheUniqs={[]}  // ✅ This prevents reloading on menu open/close
                                                reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}  // ✅ Accumulate options
                                            />
                                            {errors.case_sub_type_id && <p style={{color:"Red"}}>{errors.case_sub_type_id}</p>}
                                        </Grid>}
                                    </Grid>
                                </Grid>
                                <Grid size={{xs:12}} container className="mt-5 editor_sunsinput">
                                    <JoditEditor
                                        value={formData.content}
                                        config={{
                                            pasteHTML: '', // default paste content
                                            cleanHTML: false,
                                            askBeforePasteHTML: false,
                                            askBeforePasteFromWord: false,
                                            disablePlugins: ['pasteStorage'], // optionally disable paste-related cleanup plugins
                                            iframe: false,
                                            editHTMLDocumentMode: false,
                                            enableDragAndDropFileToEditor: false,
                                            processPasteHTML: html => {
                                            return html.replace(/</g, '&lt;').replace(/>/g, '&gt;');
                                            },
                                            enter: 'BR',
                                            beautifyHTML: false,
                                            events: {
                                                onPaste: (event) => {
                                                    console.log("Pasted!", event);
                                                },
                                            },
                                            paste: {
                                            cleanOnPaste: false,
                                            replaceNewlines: false
                                            },
                                            controls: {
                                                font: {
                                                    list: {
                                                        'calibri': 'Calibri'
                                                    }
                                                },
                                                videoUpload: {
                                                    name: "videoUpload",
                                                    tooltip: "Insert Video by URL",
                                                    icon: "video",
                                                    exec: (editor) => {
                                                        const formDiv = editor.create.fromHTML(`
                                                        <div style="padding: 20px; min-width: 400px;">
                                                            <h3 style="margin: 0 0 15px 0; color: #333;">Insert Video URL</h3>
                                                            <div style="margin-bottom: 15px;">
                                                            <label style="display: block; margin-bottom: 5px; font-weight: 600; color: #555;">
                                                                Video URL <span style="color: red;">*</span>
                                                            </label>
                                                            <input 
                                                                type="text" 
                                                                id="videoUrlInput" 
                                                                placeholder="https://example.com/video.mp4" 
                                                                style="width: 100%; padding: 10px; border: 2px solid #ddd; border-radius: 6px; font-size: 14px; box-sizing: border-box;"
                                                            />
                                                            <small style="color: #666; font-size: 12px; display: block; margin-top: 5px;">
                                                                Supported formats: MP4, WebM, OGG
                                                            </small>
                                                            </div>
                                                            
                                                            <div style="margin-bottom: 15px;">
                                                            <label style="display: block; margin-bottom: 5px; font-weight: 600; color: #555;">
                                                                Width (optional)
                                                            </label>
                                                            <input 
                                                                type="text" 
                                                                id="videoWidthInput" 
                                                                placeholder="640px or 100%" 
                                                                value="300px"
                                                                style="width: 100%; padding: 10px; border: 2px solid #ddd; border-radius: 6px; font-size: 14px; box-sizing: border-box;"
                                                            />
                                                            </div>
                                                            
                                                            <div style="margin-bottom: 20px;">
                                                            <label style="display: flex; align-items: center; cursor: pointer;">
                                                                <input 
                                                                type="checkbox" 
                                                                id="autoplayCheck"
                                                                style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer;"
                                                                />
                                                                <span style="color: #555; font-size: 14px;">Autoplay video</span>
                                                            </label>
                                                            </div>
                                                            
                                                            <div style="display: flex; gap: 10px; justify-content: flex-end;">
                                                            <button 
                                                                type="button" 
                                                                id="cancelVideoBtn" 
                                                                style="padding: 10px 20px; border: 2px solid #ddd; background: white; border-radius: 6px; cursor: pointer; font-weight: 600; color: #666; transition: all 0.2s;"
                                                            >
                                                                Cancel
                                                            </button>
                                                            <button 
                                                                type="button" 
                                                                id="insertVideoBtn" 
                                                                style="padding: 10px 20px; border: none; background: #4CAF50; color: white; border-radius: 6px; cursor: pointer; font-weight: 600; transition: all 0.2s;"
                                                            >
                                                                Insert Video
                                                            </button>
                                                            </div>
                                                        </div>
                                                        `);

                                                        const urlInput = formDiv.querySelector('#videoUrlInput');
                                                        const widthInput = formDiv.querySelector('#videoWidthInput');
                                                        const autoplayCheck = formDiv.querySelector('#autoplayCheck');
                                                        const insertBtn = formDiv.querySelector('#insertVideoBtn');
                                                        const cancelBtn = formDiv.querySelector('#cancelVideoBtn');

                                                        const dialog = editor.alert(formDiv, 'Insert Video');
                                                        
                                                        setTimeout(() => urlInput.focus(), 100);

                                                        insertBtn.onclick = () => {
                                                        const url = urlInput.value.trim();
                                                        
                                                        if (!url) {
                                                            urlInput.style.borderColor = 'red';
                                                            urlInput.focus();
                                                            return;
                                                        }

                                                        if (!url.match(/^https?:\/\/.+/i)) {
                                                            editor.alert('Please enter a valid URL starting with http:// or https://');
                                                            urlInput.style.borderColor = 'red';
                                                            urlInput.focus();
                                                            return;
                                                        }

                                                        const width = widthInput.value.trim() || '100%';
                                                        const autoplay = autoplayCheck.checked;
                                                        
                                                        let videoType = 'video/mp4';
                                                        if (url.match(/\.webm(\?.*)?$/i)) videoType = 'video/webm';
                                                        else if (url.match(/\.ogg(\?.*)?$/i)) videoType = 'video/ogg';
                                                        else if (url.match(/\.mov(\?.*)?$/i)) videoType = 'video/mp4';

                                                        const videoHTML = `
                                                            <p>
                                                            <video 
                                                                controls 
                                                                controlsList="nodownload" 
                                                                ${autoplay ? 'autoplay muted' : ''} 
                                                                width="${width}" 
                                                                style="max-width: 100%; height: auto; display: block;"
                                                            >
                                                                <source src="${url}" type="${videoType}">
                                                                Your browser does not support the video tag.
                                                            </video>
                                                            </p>
                                                        `;

                                                        editor.selection.insertHTML(videoHTML);
                                                        dialog.close();
                                                        };

                                                        cancelBtn.onclick = () => {
                                                        dialog.close();
                                                        };

                                                        insertBtn.onmouseenter = () => {
                                                        insertBtn.style.background = '#45a049';
                                                        };
                                                        insertBtn.onmouseleave = () => {
                                                        insertBtn.style.background = '#4CAF50';
                                                        };
                                                        
                                                        cancelBtn.onmouseenter = () => {
                                                        cancelBtn.style.background = '#f5f5f5';
                                                        };
                                                        cancelBtn.onmouseleave = () => {
                                                        cancelBtn.style.background = 'white';
                                                        };

                                                        urlInput.onkeypress = (e) => {
                                                        if (e.key === 'Enter') {
                                                            insertBtn.click();
                                                        }
                                                        };
                                                    }
                                                },
                                                image: {
                                                    name: 'image',
                                                    icon: 'file',
                                                    tooltip: 'Insert file'
                                                },
                                                video: {
                                                    name: 'video',
                                                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M581.7 188.1C575.5 164.4 556.9 145.8 533.4 139.5C490.9 128 320.1 128 320.1 128C320.1 128 149.3 128 106.7 139.5C83.2 145.8 64.7 164.4 58.4 188.1C47 231 47 320.4 47 320.4C47 320.4 47 409.8 58.4 452.7C64.7 476.3 83.2 494.2 106.7 500.5C149.3 512 320.1 512 320.1 512C320.1 512 490.9 512 533.5 500.5C557 494.2 575.5 476.3 581.8 452.7C593.2 409.8 593.2 320.4 593.2 320.4C593.2 320.4 593.2 231 581.8 188.1zM264.2 401.6L264.2 239.2L406.9 320.4L264.2 401.6z"/></svg>',
                                                    tooltip: 'Insert youtube video'
                                                },
                                                removeFormat: {
                                                    name: 'removeFormat',
                                                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M178.5 416l123 0 65.3-65.3-173.5-173.5-126.7 126.7 112 112zM224 480l-45.5 0c-17 0-33.3-6.7-45.3-18.7L17 345C6.1 334.1 0 319.4 0 304s6.1-30.1 17-41L263 17C273.9 6.1 288.6 0 304 0s30.1 6.1 41 17L527 199c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41l-135 135 120 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0z"/></svg>',
                                                    tooltip: 'Remove Format',
                                                },
                                                insertCodeBlock: {
                                                    name: 'insertCodeBlock',
                                                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256-64 0 0-256L128 96l0 256-64 0L64 96zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"/></svg>',
                                                    tooltip: 'Insert Code Block',
                                                    exec: (editor) => {
                                                        const codeBlockHTML = `
                                                            <div class="code-block-container"  style="margin: 10px 0; padding: 10px; background-color: #f5f5f5; border: 1px solid #ddd; border-radius: 4px;">
                                                                <div class="code-block-editor" contenteditable="true" data-jodit-temp="false" style="font-family: monospace; white-space: pre; overflow-x: auto;">// Type or paste your code here and Result of the code will be shown next to the code</div>
                                                            </div>
                                                        `;
                                                        
                                                        const currentSelection = editor.s.current();
                                                        let currentCodeBlock = null;
                                                        
                                                        let node = currentSelection;
                                                        while (node && node !== editor.editor) {
                                                            if (node.classList && 
                                                                (node.classList.contains('code-block-editor') || 
                                                                 node.classList.contains('code-block-container'))) {
                                                                currentCodeBlock = node.classList.contains('code-block-container') ? 
                                                                    node : node.closest('.code-block-container');
                                                                break;
                                                            }
                                                            node = node.parentNode;
                                                        }
                                                        
                                                        if (currentCodeBlock) {
                                                            let resultParagraph = currentCodeBlock.nextElementSibling;
                                                            
                                                            if (resultParagraph && resultParagraph.tagName === 'P' && 
                                                                resultParagraph.textContent === 'Result') {
                                                                    
                                                                editor.s.setCursorAfter(resultParagraph);
                                                                editor.s.insertHTML(codeBlockHTML);
                                                            } else {
                                                                editor.s.setCursorAfter(currentCodeBlock);
                                                                editor.s.insertHTML(codeBlockHTML);
                                                            }
                                                        } else {
                                                            editor.s.insertHTML(codeBlockHTML);
                                                        }
                                                        
                                                        const codeBlocks = editor.editor.querySelectorAll('.code-block-editor');
                                                        const newCodeBlockEditor = codeBlocks[codeBlocks.length - 1];
                                                        
                                                        if (newCodeBlockEditor) {
                                                            const handleCodeInput = function() {
                                                                const plainText = this.innerText || this.textContent;
                                                                
                                                                this.innerHTML = plainText
                                                                    .replace(/&/g, '&amp;')
                                                                    .replace(/</g, '&lt;')
                                                                    .replace(/>/g, '&gt;');
                                                            };
                                                            newCodeBlockEditor.addEventListener('paste', function(e) {
                                                                e.preventDefault();
                                                                
                                                                const text = e.clipboardData.getData('text/plain');
                                                                
                                                                const selection = window.getSelection();
                                                                const range = selection.getRangeAt(0);
                                                                range.deleteContents();
                                                                range.insertNode(document.createTextNode(text));
                                                                
                                                                handleCodeInput.call(this);
                                                                
                                                                range.setStartAfter(range.endContainer);
                                                                range.collapse(true);
                                                                selection.removeAllRanges();
                                                                selection.addRange(range);
                                                            });
                                                            
                                                            newCodeBlockEditor.addEventListener('input', function() {
                                                                handleCodeInput.call(this);
                                                            });
                                                            
                                                            newCodeBlockEditor.focus();
                                                            const selection = window.getSelection();
                                                            const range = document.createRange();
                                                            range.selectNodeContents(newCodeBlockEditor);
                                                            selection.removeAllRanges();
                                                            selection.addRange(range);
                                                        }
                                                    }
                                                },
                                                removeBg: {
                                                    name: "removeBg",
                                                    tooltip: "Remove Background Color",
                                                    icon: "eraser",
                                                    exec: (editor) => {
                                                    editor.s.focus();
                                                
                                                    const sel = editor.s.sel;
                                                    if (sel && sel.rangeCount > 0) {
                                                        const range = sel.getRangeAt(0);
                                                        const contents = range.cloneContents();
                                                        const div = editor.ownerDocument.createElement("div");
                                                        div.appendChild(contents);
                                                        
                                                        const elements = div.querySelectorAll("*");
                                                        elements.forEach(el => {
                                                        if (el.style && el.style.backgroundColor) {
                                                            el.style.backgroundColor = "";
                                                        }
                                                        });
                                                        
                                                        editor.selection.remove();
                                                        editor.selection.insertHTML(div.innerHTML);
                                                    }
                                                    }
                                                },
                                                fontsize: {
                                                    list: {
                                                    "12px": "Paragraph - 12",
                                                    "14px": "Small - 14",
                                                    "16px": "Default - 16",
                                                    "18px": "Medium - 18",
                                                    "24px": "Large - 24"
                                                    }
                                                }, 
                                            },
                                            width: "100%",
                                            minWidth: "500px",
                                            toolbarAdaptive: false,
                                            toolbarSticky: false,
                                            uploader: {
                                                insertImageAsBase64URI: true,
                                                url: '/upload-image',
                                                filesVariableName: () => 'image',
                                                accept: 'image/*',

                                                onSelect: function (files, handler) {
                                                const validImages = [];
                                                for (let file of files) {
                                                    if (file.type.startsWith('image/')) {
                                                    validImages.push(file);
                                                    } else {
                                                        this.jodit.alert(`Only image formats are allowed: ${file.name}`, 'error');
                                                    }
                                                }

                                                if (validImages.length > 0) {
                                                    handler(validImages);
                                                }
                                                },

                                                error: function (e) {
                                                this.jodit.alert('❌ Only image files are allowed or upload failed.', 'error');
                                                }
                                            },
                                            buttons: [
                                                "source", 'insertCodeBlock',"|",
                                                "bold", "italic", "underline", "strikethrough","spellcheck", "|",
                                                "fontsize", "brush","removeBg", "|", // Font size, font style, text color // "font",
                                                "ul", "ol", "|",
                                                "align", "|",
                                                "image", "videoUpload", "video", "table", "link", "|",
                                                "undo", "redo", "removeFormat", "|",
                                                "hr", "fullsize" 
                                            ], 
                                            useIframe: false,
                                            defaultFont: "calibri",
                                            style: {
                                                fontFamily: "calibri", // Set font globally
                                            },
                                            showCharsCounter: false, // Hides character counter
                                            showWordsCounter: false, // Hides word counter
                                        }}
                                        onChange={debouncedOnChange}
                                    />
                                    {errors.content && <p style={{color:"Red"}}>{errors.content}</p>}
                                </Grid>
                                <Grid size={{sm:12, xs:12}} container className="darfts_inputs" flexDirection="column" style={{position:"relative"}}>
                                    <span>Tag<small>*</small></span>
                                    <input
                                        type="text"
                                        value={input}
                                        onChange={handleInputChanger}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Type and press Enter"
                                        style={styles.input}
                                    />
                                    {suggestions.length > 0 && input.trim() !== "" && (
                                    <ul style={{ 
                                        listStyle: "none", 
                                        padding: "5px", 
                                        border: "1px solid #ccc", 
                                        borderRadius: "4px", 
                                        margin: 0, 
                                        position: "absolute", 
                                        top:"100%",
                                        background: "#fff", 
                                        width: "250px",
                                        height:"150px",
                                        overflow:"auto",
                                        zIndex: 10, 
                                    }}>
                                        {suggestions.map((tag, index) => (
                                            <li 
                                                key={index} 
                                                style={{ padding: "5px", cursor: "pointer" }} 
                                                onClick={() => handleSuggestionClick(tag)}
                                            >
                                                {tag}
                                            </li>
                                            ))}
                                        </ul>
                                    )}
                                    <div style={styles.tagContainer}>
                                        {tags.map((tag, index) => (
                                        <div key={index} style={styles.tag}>
                                            {tag}
                                            <button
                                            type="button"
                                            style={styles.removeButton}
                                            onClick={() => removeTag(index)}
                                            >
                                            &times;
                                            </button>
                                        </div>
                                        ))}
                                    </div>
                                    {errors.tags && <p style={{color:"Red"}}>{errors.tags}</p>}
                                </Grid>
                                {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                                <Grid size={{sm:12, xs:12}} container justifyContent="flex-start" className="gap-md-4 gap-2">
                                <button
                                    style={{ width: "max-content" }}
                                    className="registersendbtn2 px-4"
                                    type="submit"
                                    onClick={(e) => handleSubmit(e, "under_approval", "false")}
                                >
                                    {submitloader === "under_approval" ? (
                                        <img src={require('../../assets/whiteloader.gif')} alt='' />
                                    ) : (
                                        'Request for Approval'
                                    )}
                                </button>

                                <button
                                    className="registersendbtn1"
                                    type="submit"
                                    onClick={(e) => {handleSubmit(e, "draft", "false")}}
                                    >
                                    {(submitloader === "draft" && previewer === "false") ? (
                                        <img src={require('../../assets/pinkloader.gif')} alt='' />
                                    ) : (
                                        'Save'
                                    )} 
                                </button>

                                <button
                                    className="registersendbtn1"
                                    type='button'
                                    onClick={() => {
                                        if(!backActive){
                                            navigate("/knowledge/draft");
                                        }else{
                                            setShow(true);
                                        }
                                    }}
                                    >
                                    Back
                                    </button>
                                <button
                                    className="registersendbtn1"
                                    type="submit"
                                    onClick={(e) => handleSubmit(e, "draft", "true")}
                                    >
                                    {(submitloader === "draft" && previewer === "true") ? (
                                        <img src={require('../../assets/pinkloader.gif')} alt='' />
                                    ) : (
                                        'Preview'
                                    )}
                                    </button>
                                </Grid>
                            </Grid>
                        </form>}
                        </Grid>
                    </Tab>                    
                    <Tab eventKey="attachments" title="Attachments">
                        <Grid size={{xs:12}} container justifyContent="center" className="mt-4">
                            <Grid size={{md:8,xs:12}} container>
                                <div
                                    onDrop={handleDrop}
                                    onDragOver={handleDragOver}
                                    className='drag_uploaders align-items-center flex-column d-flex'
                                >
                                    <FontAwesomeIcon className='file_uploadericon' icon={faFileLines} />
                                    <input
                                        type="file"
                                        multiple
                                        onChange={handleFileChange}
                                        style={{ display: 'none' }}
                                        id="file-upload"
                                        ref={fileInputRef} // Attach the ref here
                                    />
                                    <label htmlFor="file-upload">
                                        Browse Files
                                    </label>
                                    <p className='w-100 mb-0 mt-3'>or drop file here</p>
                                </div>
                                {error && <div style={{ color: 'red', margin: '10px 0px' }}>{error}</div>}
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="space-between" className="mt-4">
                                <Grid size={{xs:12}} container justifyContent="space-between" className="mt-4 attach_headerspan">
                                    <Grid size={{sm:2,xs:3}} container>
                                        <span>#</span>
                                    </Grid>
                                    <Grid size={{sm:8,xs:6}} container>
                                        <span>File Name</span>
                                    </Grid>
                                    <Grid size={{sm:2,xs:3}} container>
                                        <span>Actions</span>
                                    </Grid>
                                </Grid>
                                {files.map((file, index) => (
                                    <Grid key={index} size={{xs:12}} container justifyContent="space-between" alignItems="center" className="tablelisterattach">
                                        <Grid size={{sm:2,xs:3}} container>
                                            <span>{index + 1}</span>
                                        </Grid>
                                        <Grid size={{sm:8,xs:6}} container>
                                            {editIndex === index ? (
                                                <input
                                                    className='rename_inputer'
                                                    type="text"
                                                    value={newName}
                                                    onChange={(e) => setNewName(e.target.value)}
                                                    placeholder="Enter new name"
                                                    style={{ width: '80%' }}
                                                />
                                            ) : (
                                                <span className='filenamesshow'>{file.name}</span>
                                            )}
                                        </Grid>
                                        <Grid size={{sm:2,xs:3}} container>
                                            {editIndex === index ? (
                                                <button className='change_btnattach' onClick={() => handleRenameFile(index)}>Change</button>
                                            ) : (
                                                <>
                                                    <button onClick={() => {
                                                        setEditIndex(index);
                                                        setNewName(file.name.split('.').slice(0, -1).join('.')); // Set the base name for editing
                                                    }}>
                                                        <FontAwesomeIcon icon={faPenToSquare} />
                                                    </button>
                                                    <button onClick={() => handleRemoveFile(index)}>
                                                        <FontAwesomeIcon icon={faXmark} />
                                                    </button>
                                                </>
                                            )}
                                        </Grid>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Tab>
                </Tabs>
                </Grid>
            </Grid>
            <Modal
                show={show} 
                onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    <h4 className='mb-0'>Leave Page</h4>
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex w-100 flex-column modal_register">
                    <h5>Do you want to save changes before leaving this page?</h5>
                    <p>Your changes will be lost if you leave now.</p>
                </div>
                </Modal.Body>
                <Modal.Footer>
                <button className='blue_primarymodalbtn1' onClick={handleClose}>
                    Cancel
                </button>
                <button className='blue_primarymodalbtn2' onClick={() => navigate("/knowledge/draft")}>
                    Leave
                </button>
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  )
}

export default DraftAdd
